
<button class="btn btn-sm btn-outline-primary btn-block mx-auto mt-2" type="button" (click)="onSelected(customer.CustomerId)">{{customer.Description}}</button>
